import { authSlice } from "../slices/authSlice";
import { modalSlice } from "../slices/modalSlice";
import { tooltipSlice } from "../slices/tooltipSlice";
import { twilioCallingSlice } from "../slices/twilioCallingSlice";
import { emailEditorSlice } from "../slices/emailEditorSlice";
import { themeProviderSlice } from "../slices/themeProviderSlice";
import leadsSlice from "../slices/leadsSlice";
import messagesSlice from "../slices/messagesSlice";
import leadDetailsSlice from "../slices/leadDetailsSlice";
import { dateTimeFormatSlice } from "../slices/dateTimeFormatSlice";
import { fontSettingsSlice } from "../slices/fontSettingsSlice";
import { createCampaignSlice } from "../slices/createCampaignSlice";
import { allCampaignSlice } from "../slices/allCampaignSlice";
import filterSlice from "../slices/filterSlice";
import pmsFilterSlice from "../slices/pmsFilterSlice";
import userManagementSlice from "../slices/userManagementSlice";
import sourcesSlice from "../slices/sourcesSlice";
import crmMessageSlice from "../slices/crmMessageSlice";
import crmLeadListSlice from "../slices/crmLeadListSlice";
import crmInboxSlice from "../slices/crmInboxSlice";
import playgroundLeadsSlice from "../slices/playgroundLeadsSlice";
import playgroundLeadDetailsSlice from "../slices/playgroundLeadDetailsSlice";
import playgroundMessagesSlice from "../slices/playgroundMessagesSlice";
import playgroundSourceSliceV2 from "../slices/playgroundSourceV2Slice";
import composeEmailModalSlice from "../slices/composeEmailModalSlice";
import { notificationSlice } from "../slices/notificationSlice";
import { dynamicTriggerSlice } from "../slices/dynamicTriggerSlice";
import helpdeskSlice from "../slices/helpdeskSlice";
import drawerSlice from "../slices/drawerSlice";
import sidebarSlice from "../slices/sidebarSlice";
import tasksFilterSlice from "../slices/tasksFilterSlice";
import fileManagementSlice from "../slices/fileManagementSlice";
import dealsSlice from "../slices/dealsSlice";
import verbaIQSlice from "../slices/verbaIQSlice";

export const reducers = {
  auth: authSlice.reducer,
  modal: modalSlice.reducer,
  tooltip: tooltipSlice.reducer,
  themeProvider: themeProviderSlice.reducer,
  twilioCalling: twilioCallingSlice.reducer,
  messages: messagesSlice.reducer,
  leadDetails: leadDetailsSlice.reducer,
  notifications: notificationSlice.reducer,
  v2Campaign: createCampaignSlice.reducer,
  allCampaign: allCampaignSlice.reducer,
  emailEditor: emailEditorSlice.reducer,
  leads: leadsSlice.reducer,
  dateTimeFormat: dateTimeFormatSlice.reducer,
  fontSettings: fontSettingsSlice.reducer,
  userManagement: userManagementSlice.reducer,
  filter: filterSlice,
  pmsFilter: pmsFilterSlice,
  sources: sourcesSlice.reducer,
  crmMessage: crmMessageSlice,
  crmLeadList: crmLeadListSlice,
  crmInbox: crmInboxSlice,
  playgroundLeadDetails: playgroundLeadDetailsSlice.reducer,
  playgroundMessages: playgroundMessagesSlice.reducer,
  playgroundLeads: playgroundLeadsSlice.reducer,
  playgroundSourceV2: playgroundSourceSliceV2.reducer,
  composeEmailModal: composeEmailModalSlice,
  dynamicTrigger: dynamicTriggerSlice.reducer,
  helpdesk: helpdeskSlice,
  drawer: drawerSlice,
  sidebar: sidebarSlice,
  tasksFilter: tasksFilterSlice,
  fileManagement: fileManagementSlice,
  deals: dealsSlice,
  verbaIQ: verbaIQSlice.reducer,
};

export {
  authSlice,
  modalSlice,
  tooltipSlice,
  twilioCallingSlice,
  notificationSlice,
  createCampaignSlice,
  allCampaignSlice,
  emailEditorSlice,
  themeProviderSlice,
  dateTimeFormatSlice,
  fontSettingsSlice,
  userManagementSlice,
  sourcesSlice,
  crmMessageSlice,
  crmLeadListSlice,
  playgroundLeadDetailsSlice,
  playgroundMessagesSlice,
  playgroundLeadsSlice,
  playgroundSourceSliceV2,
  composeEmailModalSlice,
  drawerSlice,
  dynamicTriggerSlice,
};
